import { Badge } from '@/shared/components/ui/badge/Badge';
import { DealerNamePlaceholder } from '../DealerNamePlaceholder';
import { ownerLabel } from '../../utils/templateOwnership';
import type { AssignedTemplate } from '../../types/templateAssignments.types';

interface Props {
  template: AssignedTemplate;
  dealerNames: ReadonlyMap<string, string>;
  isResolvingDealers?: boolean;
}

function OwnerLabel({ template, dealerNames, isResolvingDealers = false }: Props) {
  if (template.ownerDealerId === null) {
    return <Badge variant="info" size="xs">Platform</Badge>;
  }
  if (isResolvingDealers && !dealerNames.has(template.ownerDealerId)) {
    return <DealerNamePlaceholder />;
  }
  return <Badge variant="secondary" size="xs">{ownerLabel(template, dealerNames)}</Badge>;
}

export function AssignedTemplateLabel({ template, dealerNames, isResolvingDealers = false }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="font-medium">{template.name}</span>
      <OwnerLabel template={template} dealerNames={dealerNames} isResolvingDealers={isResolvingDealers} />
      {template.publishedVersionNumber === null ? (
        <Badge variant="warning" size="xs">Not published</Badge>
      ) : (
        <Badge variant="success" size="xs">Live v{template.publishedVersionNumber}</Badge>
      )}
    </div>
  );
}
